export const ROLES = {
  ACADEMIC: "ACADEMIC",
  DEPARTMENT_HEAD: "DEPARTMENT_HEAD",
  DEAN: "DEAN",
  RECTOR: "RECTOR",
  LIBRARY: "LIBRARY",
  ADMIN: "ADMIN",
};
